// Copyright (c) 2017 Deere & Company

import './reimbursement-summary-settings.scss';
import React, {Component, PropTypes} from 'react';
import ConfirmationModal from '../../../shared/components/confirmation-modal';
import Modal from '../../../product/shared/state/modal';
import PercentageIndicators from './percentage-indicators';
import ReimbursementSummarySettingsStruct from '@deere/cps-it.warranty-model-factory/lib/reimbursement-summary-settings';
import SettingsHeader from '../../shared/components/settings-header';
import {withRouter} from 'react-router';

let unListen;

function handleUserSettingsSave() {

    this.actions.updateUserSettings();

}

function handleRedIndicatorChange(value) {

    if (value) {

        const percentage = parseInt(value, 10);

        this.actions.updateRedIndicator(percentage);

    } else {

        this.actions.resetRedIndicator();
        this.actions.updateIsSaved(true);

    }

}

function handleYellowIndicatorChange(value) {

    if (value) {

        const percentage = parseInt(value, 10);

        this.actions.updateYellowIndicator(percentage);

    } else {

        this.actions.resetYellowIndicator();
        this.actions.updateIsSaved(true);

    }

}

function handleCloseConfirmationModal() {

    this.actions.closeConfirmSaveModal(this.nextLocation);

}

function handleConfirmSaveModal() {

    this.actions.confirmSaveModal(this.nextLocation);

}

class ReimbursementSummarySettings extends Component {

    componentWillMount() {

        this.props.actions.updateIsSaved(true);

        unListen = this.props.router.listenBefore(nextLocation => this.props.actions.handleOnPageLeave(nextLocation, this.props));

    }

    componentWillUnmount() {

        unListen();

    }

    render() {

        return (
            <section className='reimbursement-summary-settings'>
                <SettingsHeader
                    className='reimbursement-summary-settings-header'
                    isSaveDisabled={this.props.isSaved}
                    onSave={this.props::handleUserSettingsSave}
                    title='REIMBURSEMENT_SUMMARY'
                />
                <PercentageIndicators
                    onRedIndicatorChange={this.props::handleRedIndicatorChange}
                    onYellowIndicatorChange={this.props::handleYellowIndicatorChange}
                    reimbursementSummarySettings={this.props.reimbursementSummarySettings}
                />
                <ConfirmationModal
                    confirmMessage='DO_YOU_WANT_TO_SAVE_YOUR_CHANGES'
                    isOpen={this.props.confirmSaveModal.isVisible}
                    onClose={this.props::handleCloseConfirmationModal}
                    onConfirm={this.props::handleConfirmSaveModal}
                    title='SAVE_CHANGES'
                />
            </section>
        );

    }

}

ReimbursementSummarySettings.displayName = 'ReimbursementSummarySettings';
ReimbursementSummarySettings.propTypes = {
    actions: PropTypes.object.isRequired,
    confirmSaveModal: PropTypes.instanceOf(Modal).isRequired,
    isSaved: PropTypes.bool.isRequired,
    nextLocation: PropTypes.string.isRequired,
    reimbursementSummarySettings: PropTypes.instanceOf(ReimbursementSummarySettingsStruct).isRequired,
    router: PropTypes.object.isRequired
};

export default withRouter(ReimbursementSummarySettings);



// WEBPACK FOOTER //
// ./src/user/reimbursement-summary-settings/components/reimbursement-summary-settings.js